export class FilterDataExamRequests {
  page_size: number = 25;
  page: number = 0;
  status: string[] | null = null;
  urgent: string[] | null = null;
  patient_id: number | null = null;
  assigned_to_id: number | null = null;
  created_at: string | null = null;

  toObject(): {
    [param: string]: string | number | boolean | (string | number | boolean)[];
  } {
    return {
      page_size: this.page_size,
      page: this.page + 1, // O componente trata a primeira página como 0, mas o Django como 1
      status: this.status || [],
      urgent: this.urgent || [],
      patient_id: this.patient_id || [],
      assigned_to_id: this.assigned_to_id || [],
      created_at: this.created_at || [],
    };
  }
}
